"use client";
import { useState } from "react";
import Img from "@/public/images/login.jpg";
import Image from "next/image";
import Link from "next/link";
import Right from "@/public/icon/arrowRight.svg";
import Left from "@/public/icon/arrowLeft.svg";
import { useRouter } from "next/navigation";
import http from "@/libs/config/http";
import { useSnackbar } from "notistack";

const Forget = ({ t }) => {
  const { enqueueSnackbar } = useSnackbar();

  const [phoneNumber, setPhoneNumber] = useState("+994");
  const router = useRouter();

  const handleInputChange = (event) => {
    let value = event.target.value;

    if (value.startsWith("+994")) {
      setPhoneNumber(value);
    } else {
      setPhoneNumber("+994" + value.replace(/^(\+994)/, ""));
    }
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const phone = phoneNumber;

    register(phone);
  };
  const register = async (phone) => {
    try {
      const res = await http("auth/getResetOTP", {
        method: "POST",
        body: JSON.stringify({
          phone,
        }),
      });
      if (!res?.success) {
        enqueueSnackbar(res.message || t["error.title"], { variant: "error" });
        return;
      }

      router.push(`/auth/login-otp?phone=${phone}`);
    } catch (error) {
      console.error("Register error:", error.message);
    }
  };

  return (
    <div className="container">
      <div className="row">
        <div className="xl-6 lg-6 md-6 sm-12">
          <div className="loginLeft">
            <Link href="/auth/register" className="backToPage">
              <Left />
            </Link>
            <h1>{t["buttons_forgot_password"]}</h1>
            <form onSubmit={handleSubmit}>
              <div className="inputChild">
                <input
                  type="text"
                  required
                  placeholder={t["forms.numbers"]}
                  value={phoneNumber}
                  onChange={handleInputChange}
                />
              </div>
              <button type="submit" className="blackButton">
                {t["buttons.send"]}
                <Right />
              </button>
            </form>
          </div>
        </div>
        <div className="xl-6 lg-6 md-6 sm-12">
          <div className="img">
            <Image src={Img} alt="login" width={300} height={300} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Forget;
